import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { BYPASS_SPINNER } from "@vp/shared/tokens";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { HttpStateService } from "../service/http-state.service";

/**
 * Report the url, start and end state for requests to the httpStateService.
 * Requests sent with `BYPASS_SPINNER` are left out: the spinner tracks only the
 * latest event, so a background request would flash it, or hide it while a
 * real request is still running.
 */
@Injectable({
  providedIn: "root"
})
export class SpinnerInterceptorService implements HttpInterceptor {
  private httpStateService = inject(HttpStateService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(BYPASS_SPINNER)) {
      return next.handle(request);
    }

    this.httpStateService.start(request.url);

    return next.handle(request).pipe(
      finalize(() => {
        this.httpStateService.end(request.url);
      })
    );
  }
}
